import * as React from 'react';
import { css } from '@emotion/react';
import { theme } from '@Guidelines/Theme/theme';
import { Outlet } from 'react-router-dom';
import BrandIdentity from '@Guidelines/Component/Brand/BrandIdentity';
import readDisplayedLogo from '@Application/Branding/DisplayedLogo/readDisplayedLogo';

const pageStyle = css`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	min-height: 100vh;
	background-color: ${theme.colors.surfaceInverted};
	padding: ${theme.layout.gutter};
`;

const LoginRootPage: React.FC = () => {
	const logo = React.useMemo(readDisplayedLogo, []);

	return (
		<div css={pageStyle}>
			<BrandIdentity logo={logo} tone="dark" size="large" />
			<Outlet />
		</div>
	);
};

export default LoginRootPage;
